// SCSS
import "@/assets/scss/styles.scss";
import Paging from "@/component/Paging.vue";
import Tooltip from "@/component/Tooltip.vue";
import dayjs from "dayjs";
import filesaver from "file-saver";
import lodash from "lodash";
import { buildVueDompurifyHTMLDirective } from "vue-dompurify-html";
import axios from "./axios";

import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

const app = createApp(App);

window.addEventListener("beforeunload", () => {
    sessionStorage.setItem("wasReload", "true");
});

// 전역 에러 핸들러
app.config.errorHandler = (err, instance, info) => {
    console.error("Vue 전역 에러 발생:", err, info);
    axios.setErrorSession(500);
};

app.use(store)
    .use(router)
    .provide("axios", axios)
    .provide("dayjs", dayjs)
    .provide("lodash", lodash)
    .provide("filesaver", filesaver)
    .component("tooltip", Tooltip)
    .directive("dompurify-html", buildVueDompurifyHTMLDirective())
    .component("Paging", Paging)
    .mount("#app");
